import { Banner } from '@sunwebgroup/uds-ui/banner'
import { useIntl } from '@/intl'

export function NoReviewsMessage() {
  const intl = useIntl()
  return (
    <Banner
      size="M"
      text={intl.formatMessage({ id: 'reviews_no_reviews_title' })}
      supportingText={intl.formatMessage({ id: 'reviews_no_reviews_content' })}
      color="informative"
    />
  )
}
